export default "__VITE_ASSET__Bonp$sfL__"